/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddress } from './ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddress';
import {
    ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddressFromJSON,
    ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddressFromJSONTyped,
    ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddressToJSON,
} from './ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddress';
import type { ExecRiskBusinessName } from './ExecRiskBusinessName';
import {
    ExecRiskBusinessNameFromJSON,
    ExecRiskBusinessNameFromJSONTyped,
    ExecRiskBusinessNameToJSON,
} from './ExecRiskBusinessName';
import type { ExecRiskForeignAddress } from './ExecRiskForeignAddress';
import {
    ExecRiskForeignAddressFromJSON,
    ExecRiskForeignAddressFromJSONTyped,
    ExecRiskForeignAddressToJSON,
} from './ExecRiskForeignAddress';

/**
 * 
 * @export
 * @interface ExecRiskCompensationOfHghstPdCntrctGrp
 */
export interface ExecRiskCompensationOfHghstPdCntrctGrp {
    /**
     * 
     * @type {string}
     * @memberof ExecRiskCompensationOfHghstPdCntrctGrp
     */
    person_name?: string;
    /**
     * 
     * @type {ExecRiskBusinessName}
     * @memberof ExecRiskCompensationOfHghstPdCntrctGrp
     */
    business_name?: ExecRiskBusinessName;
    /**
     * 
     * @type {ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddress}
     * @memberof ExecRiskCompensationOfHghstPdCntrctGrp
     */
    us_address?: ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddress;
    /**
     * 
     * @type {ExecRiskForeignAddress}
     * @memberof ExecRiskCompensationOfHghstPdCntrctGrp
     */
    foreign_address?: ExecRiskForeignAddress;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskCompensationOfHghstPdCntrctGrp
     */
    service_type_txt?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskCompensationOfHghstPdCntrctGrp
     */
    compensation_amt?: number;
}

/**
 * Check if a given object implements the ExecRiskCompensationOfHghstPdCntrctGrp interface.
 */
export function instanceOfExecRiskCompensationOfHghstPdCntrctGrp(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskCompensationOfHghstPdCntrctGrpFromJSON(json: any): ExecRiskCompensationOfHghstPdCntrctGrp {
    return ExecRiskCompensationOfHghstPdCntrctGrpFromJSONTyped(json, false);
}

export function ExecRiskCompensationOfHghstPdCntrctGrpFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskCompensationOfHghstPdCntrctGrp {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'person_name': !exists(json, 'person_name') ? undefined : json['person_name'],
        'business_name': !exists(json, 'business_name') ? undefined : ExecRiskBusinessNameFromJSON(json['business_name']),
        'us_address': !exists(json, 'us_address') ? undefined : ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddressFromJSON(json['us_address']),
        'foreign_address': !exists(json, 'foreign_address') ? undefined : ExecRiskForeignAddressFromJSON(json['foreign_address']),
        'service_type_txt': !exists(json, 'service_type_txt') ? undefined : json['service_type_txt'],
        'compensation_amt': !exists(json, 'compensation_amt') ? undefined : json['compensation_amt'],
    };
}

export function ExecRiskCompensationOfHghstPdCntrctGrpToJSON(value?: ExecRiskCompensationOfHghstPdCntrctGrp | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'person_name': value.person_name,
        'business_name': ExecRiskBusinessNameToJSON(value.business_name),
        'us_address': ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddressToJSON(value.us_address),
        'foreign_address': ExecRiskForeignAddressToJSON(value.foreign_address),
        'service_type_txt': value.service_type_txt,
        'compensation_amt': value.compensation_amt,
    };
}

